import { Component, Input } from '@angular/core';

// Overview: current balance and the link to the job's transactions
// (was the left half of overview/items/item-seven; the status toggles are in the Action panel).
@Component({
  selector: 'app-overview-accounting',
  templateUrl: './overview-accounting.component.html'
})
export class OverviewAccountingComponent {
  @Input() job: any;
  @Input() balance: any;
}
